import { render, staticRenderFns } from "./NewsFeedContainer.vue?vue&type=template&id=5d3dc18b&scoped=true&"
import script from "./NewsFeedContainer.vue?vue&type=script&lang=js&"
export * from "./NewsFeedContainer.vue?vue&type=script&lang=js&"
import style0 from "./NewsFeedContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewsFeedContainer.vue?vue&type=style&index=1&id=5d3dc18b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3dc18b",
  null
  
)

export default component.exports